import { uniqueId } from "lodash";
import { computed, defineComponent, nextTick, ref, toRefs, watch } from "@vue/composition-api";
export default defineComponent({
  name: "GoogleMapWrapper",
  props: {
    geolocation: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const {
      geolocation
    } = toRefs(props);
    const mapId = ref(uniqueId("map"));
    const mapInstance = ref(null);
    const mapMarker = ref(null);
    const mapElement = ref();
    const emptyGeolocation = computed(() => !geolocation.value.location && !geolocation.value.viewport);
    const updateMapLocation = geometry => {
      var _mapInstance$value2;
      if (!geometry) return;
      if (geometry.viewport) {
        var _mapInstance$value;
        (_mapInstance$value = mapInstance.value) == null ? void 0 : _mapInstance$value.fitBounds(geometry.viewport);
      }
      (_mapInstance$value2 = mapInstance.value) == null ? void 0 : _mapInstance$value2.setZoom(17);
      if (geometry.location) {
        var _mapMarker$value, _mapMarker$value2, _mapInstance$value3;
        (_mapMarker$value = mapMarker.value) == null ? void 0 : _mapMarker$value.setPosition(geometry.location);
        (_mapMarker$value2 = mapMarker.value) == null ? void 0 : _mapMarker$value2.setVisible(true);
        (_mapInstance$value3 = mapInstance.value) == null ? void 0 : _mapInstance$value3.setCenter(geometry.location);
      }
    };
    const initMap = () => {
      if (mapElement.value) {
        mapInstance.value = new google.maps.Map(mapElement.value, {
          center: {
            lat: -33.8688,
            lng: 151.2195
          },
          zoom: 17
        });
        mapMarker.value = new google.maps.Marker({
          map: mapInstance.value,
          anchorPoint: new google.maps.Point(0, -29)
        });
      }
    };
    watch(emptyGeolocation, value => nextTick(() => {
      if (!value) initMap();
    }), {
      immediate: true
    });
    watch(geolocation, () => nextTick(() => {
      updateMapLocation(geolocation.value);
    }), {
      deep: true,
      immediate: true
    });
    return {
      mapId,
      mapElement,
      emptyGeolocation
    };
  }
});